import { css } from "styled-components";

import { fontFamily } from "../grid";


export const InputBaseStyles = css`
  position: relative;
  padding: 13px 10px;
  height: 48px;

  color: #333333;
  background-color: #f0f3f7;
  border-bottom: 1px solid #333333;
  border-radius: 4px 4px 0 0;

  &:focus,
  &:hover {
    background-color: #f0f3f7;
    border-bottom: 1px solid #333333;
  }

  /* UI/Forms/textfield */
  font:
    400 13px/20px ${fontFamily},
    "Segoe UI",
    sans-serif;
`;
